import React from "react";
import ReactDOM from "react-dom/client";
import { disableReactDevTools } from "@fvilers/disable-react-devtools";
// import * as Sentry from "@sentry/react";
//import redux
import "./index.css";
import App from "./App";
import StoreProvider from "./redux_service/StoreProvider";
import './utils/debugHelper'; // Initialize debug helper
import initCacheCleaning from './utils/clearCache'; // Cache clearing to prevent white screen

// Initialize cache cleaning on app load
initCacheCleaning();

// Initialize Tawk.to using vanilla JS (React 19 compatible)
window.Tawk_API = window.Tawk_API || {};
window.Tawk_LoadStart = new Date();
window.Tawk_API.customStyle = {
  visibility: {
    desktop: {
      xOffset: '8',
      yOffset: '50',
      position: 'bl'
    },
    mobile: {
      xOffset: 15,
      yOffset: 15,
      position: 'bl'
    }
  }
};
(function(){
  var s1 = document.createElement("script");
  var s0 = document.getElementsByTagName("script")[0];
  s1.async = true;
  s1.src = 'https://embed.tawk.to/682d9fde56f60b1911e69bb8/1irp3gvnc';
  s1.charset = 'UTF-8';
  s1.setAttribute('crossorigin', '*');
  s0.parentNode.insertBefore(s1, s0);
})();

if (process.env.NODE_ENV === "production") {
  disableReactDevTools();
  console.log = () => {};
  console.warn = () => {};
  console.info = () => {};
  console.debug = () => {};
}

// Global error handlers to prevent white screen
window.addEventListener('error', (event) => {
  console.error('=== GLOBAL ERROR CAUGHT ===');
  console.error('Message:', event.message);
  console.error('Source:', event.filename);
  console.error('Line:', event.lineno, 'Column:', event.colno);
  console.error('Error object:', event.error);
  console.error('==========================');

  // Store error for debugging
  try {
    localStorage.setItem('lastGlobalError', JSON.stringify({
      message: event.message,
      source: event.filename,
      line: event.lineno,
      column: event.colno,
      timestamp: new Date().toISOString(),
    }));
  } catch (e) {
    console.error('Failed to store error:', e);
  }

  // Prevent default error handling that might cause white screen
  // event.preventDefault();
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('=== UNHANDLED PROMISE REJECTION ===');
  console.error('Reason:', event.reason);
  console.error('Promise:', event.promise);
  console.error('===================================');

  // Store error for debugging
  try {
    localStorage.setItem('lastPromiseRejection', JSON.stringify({
      reason: event.reason?.toString() || 'Unknown',
      timestamp: new Date().toISOString(),
    }));
  } catch (e) {
    console.error('Failed to store rejection:', e);
  }

  // Prevent default handling
  // event.preventDefault();
});

// Sentry.init({
//   dsn: process.env.REACT_APP_SENTRY_DSN,
//   integrations: [
//     new Sentry.BrowserTracing({
//       // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//       tracePropagationTargets: ["localhost", "https://hi.bootyshaker.co.uk/"],
//     }),
//     new Sentry.Replay(),
//   ],
//   // Performance Monitoring
//   tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <StoreProvider>
      <App />
    </StoreProvider>
  </React.StrictMode>
);
